import { DefaultTheme } from 'styled-components'
import base from './base'
import { darkColors } from './colors'
import { dark as darkButton } from '../components/Button/theme'
import { defaultTheme as themeText } from '../components/Text/theme'
import { dark as darkToggle } from '../components/Toggle/theme'

const darkTheme: DefaultTheme = {
  ...base,
  isDark: true,
  colors: darkColors,
  button: darkButton,
  toggle: darkToggle,
  text: themeText
}

export default darkTheme
